import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import user from "./module/user";
import newServiceRenewal from "./module/newServiceRenewal";
import medal from "./module/medal";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    user,
    newServiceRenewal,
    medal
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});
